import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { get, isEmpty } from 'lodash/fp';
import { Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import { toDisplayDateTime } from '../../../helpers/dates';

import VisitOrder from './VisitOrder';
import { OrderType } from '../../../interfaces/pos';

const styles = StyleSheet.create({
  page: {
    fontSize: 11,
    padding: '0 20px 100px',
    margin: '20px 0 10px'
  },
  headerSection: {
    display: 'flex',
    flexDirection: 'row'
  },
  columnA: {
    display: 'flex',
    width: '70%'
  },
  columnB: {
    width: '30%',
    display: 'flex',
    marginLeft: 10,
    paddingLeft: 10
  },
  section: {
    marginBottom: 6,
    flexDirection: 'row'
  },
  label: {
    width: '35%',
    color: '#444',
    fontSize: 10,
    textAlign: 'left',
    marginRight: 20,
    display: 'inline',
    flexGrow: 1
  },
  value: {
    width: '70%',
    textAlign: 'left',
    display: 'inline',
    flexGrow: 1
  },
  contactNumber: {
    fontSize: 11,
    marginBottom: 2
  },
  signatureArea: {
    width: '100%',
    marginTop: 70,
    paddingTop: 3,
    textAlign: 'center',
    borderTop: '1px solid #444'
  },
  orderSection: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row'
  },
  footer: {
    position: 'absolute',
    fontSize: 10,
    bottom: 66,
    left: 20,
    right: 0,
    textAlign: 'left',
    color: 'grey'
  },
  pagination: {
    position: 'absolute',
    fontSize: 10,
    bottom: 66,
    left: 0,
    right: 20,
    textAlign: 'right',
    color: 'grey'
  }
});

const VisitOrderDetailsPdf = ({ data }) => {
  const { orders = [] } = data;
  return (
    <Page size="A4" style={styles.page} wrap>
      <View style={styles.headerSection}>
        <View style={styles.columnA}>
          <View style={styles.section}>
            <Text style={styles.label}>Guest ID:</Text>
            <Text style={styles.value}>{get('guest.id', data)}</Text>
          </View>
          <View style={styles.section}>
            <Text style={styles.label}>Guest Name:</Text>
            <Text style={styles.value}>{get('guest.name', data)}</Text>
          </View>
          <View style={styles.section}>
            <Text style={styles.label}>Visit ID:</Text>
            <Text style={styles.value}>{get('visit.id', data)}</Text>
          </View>
          <View style={styles.section}>
            <Text style={styles.label}>Visit Date:</Text>
            <Text style={styles.value}>
              {toDisplayDateTime(get('visit.visitOn', data))}
            </Text>
          </View>
          <View style={styles.section}>
            <Text style={styles.label}>Outreach ID / Name:</Text>
            <Text style={styles.value}>
              {get('outreach.id', data)} / {get('outreach.name', data)}
            </Text>
          </View>
        </View>
        <View style={styles.columnB}>
          <View style={styles.section}>
            <Text style={styles.signatureArea}>Signature</Text>
          </View>
        </View>
      </View>

      {!isEmpty(orders) && (
        <Fragment>
          <Text style={{ textAlign: 'center', margin: 5 }}>Order Items:</Text>
          <View style={styles.orderSection}>
            {orders.map(each => (
              <VisitOrder data={each} key={`order-${each.id}`} />
            ))}
          </View>
        </Fragment>
      )}
      <Text style={styles.footer} fixed>
        Visit: {get('visit.id', data)}
      </Text>
      <Text
        style={styles.pagination}
        render={({ pageNumber, totalPages }) =>
          `Page ${pageNumber} of ${totalPages}`
        }
        fixed
      />
    </Page>
  );
};

VisitOrderDetailsPdf.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
    orders: PropTypes.arrayOf(OrderType)
  }).isRequired
};

export default VisitOrderDetailsPdf;
